<template>
  <div v-if="message">
    <div class="d-flex justify-content-between align-items-center" style="min-height: 40px">
      <div class="text-dark text__message-time">
        {{ dateString(message.createdAt) }}
        <!-- <small class="ml-2" v-if="message.updatedAt"
          >Latest edited {{ dateString(message.updatedAt) }}</small
        > -->
        <small v-if="message.updatedAt" class="ml-2">(Edited)</small>
      </div>
      <div>
        <BaseEllipsis v-if="user.id == message._sender.userId" class="icon__message-dropdown">
          <b-dropdown-item v-if="!message.isFileMessage" @click="isEdit = !isEdit">
            {{ isEdit ? 'Cancel' : 'Edit' }}
          </b-dropdown-item>

          <b-dropdown-item
            @click.prevent.stop="showModal(`ModalDeleteMessage__${message.messageId}`)"
          >
            Delete
          </b-dropdown-item>
        </BaseEllipsis>
        <ModalDeleteMessage
          :ref="`ModalDeleteMessage__${message.messageId}`"
          :channel-url="channelUrl"
          :message="message"
        />
      </div>
    </div>

    <BaseUserProfile :user-name="message._sender.nickname">
      <template slot="name">
        <div class="ml-2">
          <div class="text-dark mb-2">
            {{ message._sender.nickname }}
          </div>
        </div>
      </template>
    </BaseUserProfile>

    <!-- Content -->
    <div class="response__content mb-3">
      <div v-if="!isEdit">
        <div
          v-if="message.isPlainMessage"
          v-safe-html="message.message"
          class="text-pre-wrap text__description text__user-message"
        />

        <BaseFilesList
          v-if="message.isFileMessage"
          class="attachment__message"
          :attachments="[message]"
        />
      </div>

      <div v-else class="pl-0">
        <ResponseBlock
          :channel-url="channelUrl"
          :message="message"
          :is-footer="false"
          @onActionMessageSuccess="onActionMessageSuccess"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BaseUserProfile, BaseEllipsis, BaseFilesList } from '@/components/base-components';
import { datetimeMixin } from '@/mixins';
import { Message, User } from '@/models';
import ResponseBlock from './ResponseBlock';
import ModalDeleteMessage from './ModalDeleteMessage';

export default {
  name: 'BodyMessage',

  components: {
    BaseUserProfile,
    BaseEllipsis,
    BaseFilesList,
    ResponseBlock,
    ModalDeleteMessage
  },

  mixins: [datetimeMixin],

  props: {
    channelUrl: {
      type: String,
      default: ''
    },

    message: {
      type: Message,
      default: null
    },

    user: {
      type: User,
      default: null
    }
  },

  data() {
    return {
      isEdit: false
    };
  },

  methods: {
    dateString(date) {
      return `
        ${this.formatedDatetime(date, 'MMM D, YYYY hh:mma ')}
        ${this.cityTimezone} time`;
    },

    showModal(modalType) {
      this.$refs[modalType].show(modalType);
    },

    onActionMessageSuccess() {
      this.$emit('onActionMessageSuccess');

      this.isEdit = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.response__date {
  color: rgba(7, 9, 25, 0.5);
}

.response__content {
  margin-left: 56px;
}

.direct-message-block {
  border-bottom: 2px solid #eeeff8;
}
</style>
